module.exports = __webpack_public_path__ + "img/plus-icon.105c939d.svg";